import { render } from "./CategoryChooser.vue?vue&type=template&id=6ea94538&scoped=true"
import script from "./CategoryChooser.vue?vue&type=script&lang=js"
export * from "./CategoryChooser.vue?vue&type=script&lang=js"

import "./CategoryChooser.vue?vue&type=style&index=0&id=6ea94538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea94538"]])

export default __exports__